import React, { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import CoverageReport from '../CoverageReport';
import StyledTab from '../common/StyledTab';

const UnitTesting = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <Paper sx={{ p: 1 }}>
        {/* <Typography variant="h6">Unit Testing</Typography> */}
        <CoverageReport />

        {/* <Typography variant="body1">This section will display unit testing results.</Typography> */}
      </Paper>
    </>

  )

};

export default UnitTesting;
